module.exports = __webpack_public_path__ + "mainassets/img/faq-intro.c61aba0a.svg";